import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { TLocation } from '~/features/agents/models'
import { queryKeys } from '~/features/agents/utils'
import { EHttpService, EServerPath } from '~/models/api'
import HttpService from '~/services/http'
import { HttpServiceBaseResponse } from '~/services/http/models'
import { store } from '~/store'

const getLocations = async ({ orgId }: { orgId: string }) =>
  HttpService.get<TLocation[]>(
    {
      path: EServerPath.locations,
      query: { orgId },
    },
    EHttpService.agent,
  )

type TQueryOptions = Omit<
  UseQueryOptions<HttpServiceBaseResponse<TLocation[]>>,
  'queryFn' | 'queryKey'
>

type TProps = {
  options?: TQueryOptions
}

function useGetLocations({ options }: TProps = {}) {
  const orgId = store((state) => state.user.organizationId) || ''
  const { enabled: optionsEnabled, ...restOptions } = options || {}

  return useQuery({
    enabled: !!orgId && (optionsEnabled ?? true),
    queryKey: queryKeys.locations(orgId),
    queryFn: () => getLocations({ orgId }),
    ...restOptions,
  })
}

export default useGetLocations
